// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"Info-primaryButton-qvC1jG","description":"Info-description-1epVE7"};